/**
 * Hides the part of the email after and including the @ symbol.
 * @param email
 * @returns {string}
 */
export function obscureEmail(email) {
  const emailParts = email.split("@");
  return emailParts[0];
}
